module.exports = __webpack_public_path__ + "static/gradient_violet-5b5b307e85dfb843ff025fd3af57df35.jpg";